"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _Label = _interopRequireDefault(require("../Label"));
var _Slider = _interopRequireDefault(require("./Slider"));
var _slidermulti = require("./slidermulti.style");
var _ErrorMessage = _interopRequireDefault(require("../ErrorMessage"));
var _Hint = _interopRequireDefault(require("../Hint"));
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const MultiSlider = _a => {
  var {
      label,
      disabled,
      className,
      fit = 'medium',
      min = 0,
      max = 100,
      id,
      loading,
      onChange,
      leftScrollValue = min,
      rightScrollValue = max,
      hint,
      error,
      hideMultiSliderValues = false
    } = _a,
    rest = __rest(_a, ["label", "disabled", "className", "fit", "min", "max", "id", "loading", "onChange", "leftScrollValue", "rightScrollValue", "hint", "error", "hideMultiSliderValues"]);
  const [minVal, setMinVal] = (0, _react.useState)(min);
  const [maxVal, setMaxVal] = (0, _react.useState)(max);
  const minValRef = (0, _react.useRef)(min);
  const maxValRef = (0, _react.useRef)(max);
  const range = (0, _react.useRef)(null);
  // Convert to percentage
  const getPercent = (0, _react.useCallback)(value => Math.round((value - min) / (max - min) * 100), [min, max]);
  // on load setting values for min and max
  (0, _react.useEffect)(() => {
    const value = Math.min(Number(leftScrollValue), rightScrollValue - 1);
    setMinVal(value);
    minValRef.current = value;
    const value1 = Math.max(Number(rightScrollValue), leftScrollValue + 1);
    setMaxVal(value1);
    maxValRef.current = value1;
  }, []);
  // Set width of the range to decrease from the left side
  (0, _react.useEffect)(() => {
    const minPercent = getPercent(minVal);
    const maxPercent = getPercent(maxValRef.current);
    if (range.current) {
      range.current.style.left = "".concat(minPercent, "%");
      range.current.style.width = "".concat(maxPercent - minPercent, "%");
    }
  }, [minVal, getPercent]);
  // Set width of the range to decrease from the right side
  (0, _react.useEffect)(() => {
    const minPercent = getPercent(minValRef.current);
    const maxPercent = getPercent(maxVal);
    if (range.current) {
      range.current.style.width = "".concat(maxPercent - minPercent, "%");
    }
  }, [maxVal, getPercent]);
  const handleMultiChange = (event, type) => {
    let value;
    if (type === 'left') {
      value = Math.min(Number(event.target.value), maxVal - 1);
      setMinVal(value);
      minValRef.current = value;
    } else {
      value = Math.max(Number(event.target.value), minVal + 1);
      setMaxVal(value);
      maxValRef.current = value;
    }
    if (typeof onChange === 'function') {
      type === 'left' ? onChange(event, value, maxVal) : onChange(event, minVal, value);
    }
  };
  return (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [label && (0, _jsxRuntime.jsx)(_Label["default"], (0, _extends2["default"])({
      id: "".concat(id, "-label}"),
      label: label
    }, rest)), (0, _jsxRuntime.jsxs)(_slidermulti.MultiSlidersComponents.Wrapper, (0, _extends2["default"])({
      disabled: disabled,
      className: "".concat(className, "-wrapper"),
      fit: fit
    }, {
      children: [(0, _jsxRuntime.jsx)(_Slider["default"], (0, _extends2["default"])({}, rest, {
        scrollThumb: true,
        id: id + 'scroll-left',
        min: min,
        max: max,
        value: leftScrollValue,
        onChange: e => handleMultiChange(e, 'left'),
        className: "thumb thumb--left",
        style: {
          zIndex: minVal > max - 100 ? '5' : ''
        },
        disabled: disabled,
        fit: fit,
        hideValues: true
      })), (0, _jsxRuntime.jsx)(_Slider["default"], (0, _extends2["default"])({}, rest, {
        loading: loading,
        id: id + 'scroll-right',
        min: min,
        max: max,
        value: rightScrollValue,
        onChange: e => handleMultiChange(e, 'right'),
        className: "thumb thumb--right",
        disabled: disabled,
        scrollThumb: true,
        fit: fit,
        hideValues: true
      })), (0, _jsxRuntime.jsxs)("div", (0, _extends2["default"])({
        className: "slider"
      }, {
        children: [(0, _jsxRuntime.jsx)("div", {
          className: "slider__track"
        }), (0, _jsxRuntime.jsx)("div", {
          ref: range,
          className: "slider__range"
        }), !hideMultiSliderValues && (0, _jsxRuntime.jsx)("div", (0, _extends2["default"])({
          className: "slider__left-value"
        }, {
          children: minVal
        })), !hideMultiSliderValues && (0, _jsxRuntime.jsx)("div", (0, _extends2["default"])({
          className: "slider__right-value"
        }, {
          children: maxVal
        }))]
      }))]
    })), (0, _jsxRuntime.jsxs)("div", (0, _extends2["default"])({
      style: {
        padding: '12px 0'
      }
    }, {
      children: [error && (0, _jsxRuntime.jsx)(_ErrorMessage["default"], (0, _extends2["default"])({}, rest)), hint && (0, _jsxRuntime.jsx)(_Hint["default"], (0, _extends2["default"])({
        hint: hint,
        fit: fit
      }, rest))]
    }))]
  });
};
var _default = exports["default"] = MultiSlider;